import { post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import { createChangeTableSettingAction } from '../../../form/state/table-state-helper'

export const changeTaskTableSetting = createChangeTableSettingAction(type.CHANGE_TASK_TABLE_SETTINGS)

export const changeStateTableSetting = createChangeTableSettingAction(type.CHANGE_STATE_TABLE_SETTINGS)


export const changeUserSelection = (name, value) => ({
    type: type.CHANGE_USER_SELECTION,
    payload: {
        name,
        value,
    },
})

export const getStateAnalyticsRequest = () => ({
    type: type.GET_STATE_ANALYTICS_REQUEST,
})

export const getStateAnalyticsSuccess = (stateAnalytics) => ({
    type: type.GET_STATE_ANALYTICS_SUCCESS,
    payload: {
        stateAnalytics,
    },
})

export const getStateAnalyticsError = (error) => ({
    type: type.GET_STATE_ANALYTICS_ERROR,
    payload: {
        error,
    },
})


export const getStateAnalytics = () => (dispatch, getState) => {
    const state = getState()
    const userSelection = selector.selectUserSelection(state)

    if (!userSelection.responsible) {
        return
    }

    dispatch(getStateAnalyticsRequest())
    post('/api/process/analytics/state-responsible', userSelection)
        .then(stateAnalytics => {
            dispatch(getStateAnalyticsSuccess(stateAnalytics))
        })
        .catch(error => {
            dispatch(getStateAnalyticsError(error))
        })
}


export const getStateLastChangedRequest = () => ({
    type: type.GET_STATE_LAST_CHANGED_REQUEST,
})

export const getStateLastChangedSuccess = (stateByLastChangedList, stateName) => ({
    type: type.GET_STATE_LAST_CHANGED_SUCCESS,
    payload: {
        stateByLastChangedList,
        stateName,
    },
})

export const getStateLastChangedError = (error) => ({
    type: type.GET_STATE_LAST_CHANGED_ERROR,
    payload: {
        error,
    },
})

export const getStateLastChanged = (stateName) => (dispatch, getState) => {
    const state = getState()
    const userSelection = {
        ...selector.selectUserSelection(state),
        stateName,
    }

    dispatch(getStateLastChangedRequest())
    post('/api/process/analytics/state-last-changed', userSelection)
        .then(stateByLastChangedList => {
            dispatch(getStateLastChangedSuccess(stateByLastChangedList, stateName))
        })
        .catch(error => {
            dispatch(getStateLastChangedError(error))
        })
}


export const getTaskByDueDateRequest = () => ({
    type: type.GET_TASK_BY_DUE_DATE_REQUEST,
})

export const getTaskByDueDateSuccess = (taskByDueDateList, taskName) => ({
    type: type.GET_TASK_BY_DUE_DATE_SUCCESS,
    payload: {
        taskByDueDateList,
        taskName,
    },
})

export const getTaskByDueDateError = (error) => ({
    type: type.GET_TASK_BY_DUE_DATE_ERROR,
    payload: {
        error,
    },
})

export const getTaskByDueDate = (taskName) => (dispatch, getState) => {
    const state = getState()
    const userSelection = {
        ...selector.selectUserSelection(state),
        taskName,
    }

    dispatch(getTaskByDueDateRequest())
    post('/api/process/analytics/task-by-due-date', userSelection)
        .then(taskByDueDateList => {
            dispatch(getTaskByDueDateSuccess(taskByDueDateList, taskName))
        })
        .catch(error => {
            dispatch(getTaskByDueDateError(error))
        })
}


export const findTaskByWeekDiffRequest = () => ({
    type: type.FIND_TASK_BY_WEEK_DIFF_DATE_REQUEST,
})

export const findTaskByWeekDiffSuccess = (taskList) => ({
    type: type.FIND_TASK_BY_WEEK_DIFF_DATE_SUCCESS,
    payload: {
        taskList,
    },
})

export const findTaskByWeekDiffError = (error) => ({
    type: type.FIND_TASK_BY_WEEK_DIFF_DATE_ERROR,
    payload: {
        error,
    },
})

export const findTaskByWeekDiff = (taskByDueDateListIndex) => (dispatch, getState) => {
    const state = getState()
    const userSelection = {
        ...selector.selectUserSelection(state),
        taskName: selector.selectCurrentTaskName(state),
        weekDiff: selector.selectTaskWeekDiffByIndex(state, taskByDueDateListIndex),
    }
    dispatch(findTaskByWeekDiffRequest())
    post('/api/process/analytics/task-by-week-diff', userSelection)
        .then(taskList => {
            dispatch(findTaskByWeekDiffSuccess(taskList))
        })
        .catch(error => {
            dispatch(findTaskByWeekDiffError(error))
        })
}


export const findProcessInstanceByWeekDiffRequest = () => ({
    type: type.FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_REQUEST,
})

export const findProcessInstanceByWeekDiffSuccess = (processInstanceList) => ({
    type: type.FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_SUCCESS,
    payload: {
        processInstanceList,
    },
})

export const findProcessInstanceByWeekDiffError = (error) => ({
    type: type.FIND_PROCESS_INSTANCE_BY_WEEK_DIFF_DATE_ERROR,
    payload: {
        error,
    },
})

export const findProcessInstanceByWeekDiff = (stateByDueDateListIndex) => (dispatch, getState) => {
    const state = getState()
    const userSelection = {
        ...selector.selectUserSelection(state),
        stateName: selector.selectCurrentStateName(state),
        weekDiff: selector.selectStatekDiffByIndex(state, stateByDueDateListIndex),
    }
    dispatch(findProcessInstanceByWeekDiffRequest())
    post('/api/process/analytics/process-instance-by-week-diff', userSelection)
        .then(processInstanceList => {
            dispatch(findProcessInstanceByWeekDiffSuccess(processInstanceList))
        })
        .catch(error => {
            dispatch(findProcessInstanceByWeekDiffError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/analytics/state/state-responsible/action.js